
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'

import {mapGetters} from 'vuex';
import Vlogin from '../../components/popUp';
import Tips from '@/components/Tips';
import api from '../../api';

export default {





components: {
Group,
Cell,
Badge,
Vlogin,
Tips,
},
mounted() {
this.getOldData();
},
activated() {
},
data() {
return {
defaultUrl: require('../../assets/images/logo_G7@2x.png'),
show: false,
formData: {
avatar: '',
companyStatus: 0,
contactCount: 0,
email: '',
imgCount: 0,
mobile: '',
position: '',
realname: '',
telephone: '',
username: '',
}

};
},
watch: {
isPopLogin(val) {
if (!val) {
this.getOldData();
}
},
userInfo() {
this.getOldData();
},
},
computed: {
...mapGetters([
'isLower',
'isUpper',
]),
isPopLogin() {
return this.$store.state.isPopLogin;
},
isLogin() {
return this.$store.state.isLogin;
},
userInfo() {
return this.$store.state.userInfo;
},
companyStatus() {
return this.$store.state.companyStatus;
},
state() {
let state = '未入驻';
switch (this.formData.companyStatus) {
case 1:
state = '待审核'
break;
case 2:
state = '已审核'
break;
case 3:
state = '审核不通过'
break;
default:
state = '未入驻'
break;
}
return state;
}
},
methods: {
checkAuth(companyStatus) {
const isNotAuth = (companyStatus === 0 || companyStatus === 1 || companyStatus === 3 ) && this.isLogin;
if (!isNotAuth) return;
AlertModule.show({
title: '提示',
content: '您还未完成G7认证，不能参与招投标。点击上方立即入驻，完善资料修改->认证申请。',
})
},
goToTender(type) {
if (this.isUpper) {
this.$router.push({
name: 'tendering',
query: {
type,
},
});
} else {
this.$router.push({
name: 'tenderingL',
query: {
type,
},
});
}

},
goToBaseMsg() {
if (!this.isLogin) {
return;
}
if (window.phone_ios()) {
this.$router.push({
name: 'mineBaseDetail',
});

return false;
}
this.$router.push({
name: 'mineBaseMsg',
});
},
popLogin() {
this.$store.commit('updateIsPopLogin', true);
},
closePop() {


},
getOldData() {
if (this.isLogin) {
api.vega.user.getUserInfo({}).then((res) => {
const data = res.data.data;
this.formData = data;
this.$store.commit('updateCompanyStatus', data.companyStatus);
this.checkAuth(data.companyStatus);
});
}
},
goToCollect() {
this.$router.push({
name: 'collect',
})
},
goEnter() {

this.$router.push({
name: 'authCompanyInfo',
})
},
},
};
